import logo from "../assets/Sakura Logo.svg";
import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { texts } from "../data/texts";
import { LanguageContext } from "../data/LanguageContext";

const Header = () => {
    const { language, changeLanguage } = useContext(LanguageContext);

    return (
        <header>
            <div className="container">
                <div className="logo">
                    <Link to="/">
                        <img src={logo} alt="Tarot Insights Logo" />
                    </Link>
                </div>
                <nav>
                    <Link to="/">{texts[language].headerHome}</Link>
                    <Link to="/reading">{texts[language].headerReading}</Link>
                    <Link to="/about">{texts[language].headerAbout}</Link>
                    <Link to="/contact">{texts[language].headerContact}</Link>
                </nav>
                <button onClick={() => changeLanguage(language === 'de' ? 'en' : 'de')} className="text-sm text-gray-600">
                    {language === 'de' ? 'DE' : 'EN'} {/* Zeigt die Abkürzung der aktuellen Sprache an */}
                </button>
            </div>
        </header>
    );
};

export default Header;
